module.exports = {
      id: "allens-logo-usage",
      viewBox: "0 0 145 38",
      url: __webpack_public_path__ + "images/sprites.min-d74ccbd1d7024c3900825deb83d1d70d.svg#allens-logo-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__ale001/components/site/sprites/allens-logo.svg
// module id = /tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__ale001/components/site/sprites/allens-logo.svg
// module chunks = site__ale001